import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import {
  SUBPATH_EVENT_PARAM,
  currentSubpathEventLabel,
} from 'src/app/@utils/base-path';

/** Re-adds ?event= to every in-app URL in subpath mode, unless the path already names that event. */
export class SubpathUrlSerializer extends DefaultUrlSerializer {
  constructor(
    private readonly _label: () => string | null = () =>
      currentSubpathEventLabel(),
    private readonly _pathLabel: () => string | null = () => null
  ) {
    super();
  }

  override serialize(tree: UrlTree): string {
    const label = this._label();
    if (
      label &&
      label !== this._pathLabel() &&
      !tree.queryParams[SUBPATH_EVENT_PARAM]
    ) {
      const copy = this.parse(super.serialize(tree));
      copy.queryParams = { ...copy.queryParams, [SUBPATH_EVENT_PARAM]: label };
      return super.serialize(copy);
    }
    return super.serialize(tree);
  }
}
